var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBrowse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13991_18657)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.3333 13.5417H15.0833C14.8071 13.5417 14.5421 13.6514 14.3468 13.8468C14.1514 14.0421 14.0417 14.3071 14.0417 14.5834V20.8334C14.0417 21.1096 14.1514 21.3746 14.3468 21.5699C14.5421 21.7653 14.8071 21.875 15.0833 21.875H21.3333C21.6096 21.875 21.8746 21.7653 22.0699 21.5699C22.2653 21.3746 22.375 21.1096 22.375 20.8334V14.5834C22.375 14.3071 22.2653 14.0421 22.0699 13.8468C21.8746 13.6514 21.6096 13.5417 21.3333 13.5417Z",
    fill: "#6535E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.79167 13.5417C5.49375 13.5417 3.625 15.4104 3.625 17.7084C3.625 20.0063 5.49375 21.875 7.79167 21.875C10.0896 21.875 11.9583 20.0063 11.9583 17.7084C11.9583 15.4104 10.0896 13.5417 7.79167 13.5417Z",
    fill: "#6535E9",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2083 3.125C15.9104 3.125 14.0417 4.99375 14.0417 7.29167C14.0417 9.58958 15.9104 11.4583 18.2083 11.4583C20.5063 11.4583 22.375 9.58958 22.375 7.29167C22.375 4.99375 20.5063 3.125 18.2083 3.125Z",
    fill: "#6535E9",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9167 3.125H4.66667C4.3904 3.125 4.12545 3.23475 3.9301 3.4301C3.73475 3.62545 3.625 3.8904 3.625 4.16667V10.4167C3.625 10.6929 3.73475 10.9579 3.9301 11.1532C4.12545 11.3486 4.3904 11.4583 4.66667 11.4583H10.9167C11.1929 11.4583 11.4579 11.3486 11.6532 11.1532C11.8486 10.9579 11.9583 10.6929 11.9583 10.4167V4.16667C11.9583 3.8904 11.8486 3.62545 11.6532 3.4301C11.4579 3.23475 11.1929 3.125 10.9167 3.125Z",
    fill: "#6535E9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13991_18657"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrowse);
export default __webpack_public_path__ + "static/media/browse.4c7b692c51023a7d39ab77ba6413f274.svg";
export { ForwardRef as ReactComponent };